/**
 * TayTae Sticker Animations
 *
 * 1. Scroll-entrance  — stickers fade+bounce in when they enter the viewport
 * 2. Parallax         — hero stickers drift at different speeds as you scroll,
 *                       clamped so nothing flies off screen
 *
 * All effects respect prefers-reduced-motion.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─────────────────────────────────────────────────────────
     1. SCROLL ENTRANCE
  ───────────────────────────────────────────────────────── */
  var allStickers = document.querySelectorAll('.sticker');

  if (reducedMotion) {
    /* Skip entrance animation — just show them */
    allStickers.forEach(function (el) {
      el.classList.add('sticker--visible');
    });
  } else {
    var entranceObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sticker--visible');
            entranceObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    allStickers.forEach(function (el) {
      entranceObserver.observe(el);
    });
  }

  /* ─────────────────────────────────────────────────────────
     2. PARALLAX — hero stickers drift at different depths on scroll
     Add data-parallax="0.06" and data-base-transform="rotate(-14deg)"
     to any element. Offset is clamped so stickers stay in view.
  ───────────────────────────────────────────────────────── */
  if (!reducedMotion) {
    var parallaxEls = document.querySelectorAll('[data-parallax]');

    if (parallaxEls.length) {
      var ticking = false;

      function updateParallax() {
        var scrollY = window.pageYOffset;
        parallaxEls.forEach(function (el) {
          var speed         = parseFloat(el.dataset.parallax) || 0.06;
          var baseTransform = el.dataset.baseTransform || '';
          /* Negative offset = drifts upward as you scroll down (foreground depth)
             Clamped at ±55px so stickers never race off screen */
          var raw    = scrollY * speed * -1;
          var offset = Math.max(-55, Math.min(55, raw));
          el.style.transform = baseTransform + ' translateY(' + offset + 'px)';
        });
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }, { passive: true });

      /* Run once on load */
      updateParallax();
    }
  }

})();
